/**
 * Date / KPI helpers — extracted from AdminDashboard.
 *
 * `computeWaitlistKpis(entries)` returns today / week / month / all-time
 * deltas suitable for KPI cards. Each helper rounds to the start of the
 * period so day-boundary entries land in the expected bucket.
 */

export function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function startOfWeek() {
  // Week starts Sunday — simplest 7-day rolling window
  const d = startOfToday();
  d.setDate(d.getDate() - d.getDay());
  return d;
}

export function startOfMonth() {
  const d = startOfToday();
  d.setDate(1);
  return d;
}

export function startOfYesterday() {
  const d = startOfToday();
  d.setDate(d.getDate() - 1);
  return d;
}

export function startOfLastWeek() {
  const d = startOfWeek();
  d.setDate(d.getDate() - 7);
  return d;
}

export function startOfLastMonth() {
  const d = startOfMonth();
  d.setMonth(d.getMonth() - 1);
  return d;
}

export function countBetween(entries, fromDate, toDate) {
  const from = fromDate.getTime();
  const to = toDate ? toDate.getTime() : Number.POSITIVE_INFINITY;
  let n = 0;
  for (const e of entries) {
    const t = e.created_at ? new Date(e.created_at).getTime() : NaN;
    if (Number.isFinite(t) && t >= from && t < to) n += 1;
  }
  return n;
}

export function computeWaitlistKpis(entries) {
  const now = new Date();
  const T0 = startOfToday();
  const W0 = startOfWeek();
  const M0 = startOfMonth();
  const Yd = startOfYesterday();
  const Wlast = startOfLastWeek();
  const Mlast = startOfLastMonth();

  const today     = countBetween(entries, T0, now);
  const yesterday = countBetween(entries, Yd, T0);
  const week      = countBetween(entries, W0, now);
  const lastWeek  = countBetween(entries, Wlast, W0);
  const month     = countBetween(entries, M0, now);
  const lastMonth = countBetween(entries, Mlast, M0);

  return {
    today:   { value: today,            delta: today - yesterday, label: "vs yesterday" },
    week:    { value: week,             delta: week - lastWeek,   label: "vs last week" },
    month:   { value: month,            delta: month - lastMonth, label: "vs last month" },
    allTime: { value: entries.length,   delta: null,              label: "all-time" },
  };
}
